import styled, { css } from 'styled-components'
import theme from 'live/services/theme'
import LiveSelect from 'live/components/forms/ui/select'

export const AssetInputContainer = styled.div<{ error?: boolean }>`
    .form-control {
        ${({ error }) =>
            error &&
            css`
                border: 1px solid ${({ theme }) => theme['brand-danger']};
            `};
    }

    > small {
        display: ${({ error }) => (error ? 'block' : 'none')};
        color: ${({ theme }) => theme['brand-danger']};
    }
`

export const Select = styled(LiveSelect)<{ error?: boolean }>`
    ${({ error }) =>
        error &&
        css`
            .Select-control {
                border: 1px solid ${theme['brand-danger']};
            }
        `}
    margin-bottom:0;
`

export const SelectContainer = styled.div<{ error?: boolean }>`
    .form-group .Select-control {
        ${({ error }) =>
            error &&
            css`
                border: none;
            `};
    }

    .live-select.form-group {
        margin-bottom: 0;
        ${({ error }) =>
            error &&
            css`
                margin-bottom: 5px;
                border: 1px solid ${theme['brand-danger']};
                border-radius: 2px;
            `};
    }

    > small {
        display: ${({ error }) => (error ? 'block' : 'none')};
        color: ${theme['brand-danger']};
    }
`
